import {
  EditSubscriberRequest,
  FolderStructure,
  IInsertionSubscriber,
  ISubscriber,
  ISubscriberAdminsSimplified,
  SaveFolderStructureRequest,
} from '../../api-client/autogenerated';
import { ApiClient } from '../../api-client/api-client';

// GET //

// eslint-disable-next-line import/prefer-default-export
export const getSubscribers = async (limit = 50): Promise<ISubscriber[]> => {
  const response = await ApiClient.getAllSubscribers({ pageSize: limit });
  return response.data.results;
};

// eslint-disable-next-line import/prefer-default-export
export const getSubscriberById = async (id: string): Promise<ISubscriber> => {
  const response = await ApiClient.getSubscriberById({ subscriberId: id });
  return response.data;
};

export const getSubscriberAdminsSimplifiedBySubscriberId = async (
  id: string,
): Promise<ISubscriberAdminsSimplified> => {
  const response = await ApiClient.getSubscriberAdminsSimplifiedBySubscriberId({
    subscriberId: id,
  });
  return response.data;
};

export const getSubscriberProjectUserSummary = async (subscriberId: string) => {
  return ApiClient.getSubscriberProjectUserSummaryById({ subscriberId }).then((res) => res.data);
};

/** Every user in the subscriber with their activity totals. Subscriber admins only. */
export const getSubscriberUserActivitySummary = async (subscriberId: string) => {
  return ApiClient.getSubscriberUserActivitySummaryById({ subscriberId }).then((res) => res.data);
};

export const getAllProjectNamesBySubscriberId = async (subscriberId: string) => {
  return ApiClient.getAllProjectNamesBySubscriberId({ subscriberId }).then((res) => res.data);
};

/** Every named default folder structure the subscriber keeps, with the folders each one creates. */
export const getSubscriberFolderStructures = async (
  subscriberId: string,
): Promise<FolderStructure[]> => {
  return ApiClient.getFolderStructuresBySubscriberId({ subscriberId }).then((res) => res.data);
};

// POST //

export const insertSubscriber = async (subscriber: IInsertionSubscriber): Promise<number> => {
  return (await ApiClient.insertSubscriber({ iInsertionSubscriber: subscriber })).status;
};

export const insertSubscriberFolderStructure = async (
  subscriberId: string,
  structure: SaveFolderStructureRequest,
): Promise<FolderStructure> => {
  return ApiClient.insertFolderStructureBySubscriberId({
    subscriberId,
    saveFolderStructureRequest: structure,
  }).then((res) => res.data);
};

// PATCH //

/** Replaces the structure's name, description and whole folder tree. */
export const updateSubscriberFolderStructure = async (
  subscriberId: string,
  folderStructureId: string,
  structure: SaveFolderStructureRequest,
): Promise<FolderStructure> => {
  return ApiClient.editFolderStructureBySubscriberId({
    subscriberId,
    folderStructureId,
    saveFolderStructureRequest: structure,
  }).then((res) => res.data);
};

export const updateSubscriber = async (
  subscriberId: string,
  subscriber: EditSubscriberRequest,
): Promise<number> => {
  return (
    await ApiClient.editSubscriberById({
      subscriberId,
      editSubscriberRequest: subscriber,
    })
  ).status;
};

// DELETE //

export const deleteSubscriber = async (subscriberId: string): Promise<number> => {
  return (await ApiClient.deleteSubscriberById({ subscriberId })).status;
};

export const deleteSubscriberFolderStructure = async (
  subscriberId: string,
  folderStructureId: string,
): Promise<void> => {
  await ApiClient.deleteFolderStructureBySubscriberId({ subscriberId, folderStructureId });
};

export const removeUserFromAllProjects = async (subscriberId: string, userId: string) => {
  return ApiClient.removeUserFromAllProjectsBySubscriberId({ subscriberId, userId }).then(
    (res) => res.data,
  );
};
